<template>
  <div class="main">
    <div class="maincon">
      <!-- <div class="bread">首页 > 我的玫德 > 我的订单</div> -->
      <div class="flexbox tabs">
        <div
          class="selcell"
          :class="{
            active:
              currentstate == '1' ||
              currentstate == '2' ||
              currentstate == '3' ||
              currentstate == '4',
          }"
        >
          <el-select
            v-model="dateStateS"
            placeholder="请选择"
            @change="stateChange"
            @focus="focusstate"
          >
            <el-option
              v-for="item in dateState"
              :key="item.val"
              :label="item.name"
              :value="item.val"
            >
            </el-option>
          </el-select>
        </div>
        <div
          class="cell"
          :class="{ active: currentstate == '0' }"
          @click="tabSwitch('0')"
        >
          全部订单
        </div>
        <div
          class="cell"
          :class="{ active: currentstate == '5' }"
          @click="tabSwitch('5')"
        >
          待发货
        </div>
        <div
          class="cell"
          :class="{ active: currentstate == '6' }"
          @click="tabSwitch('6')"
        >
          待收货
        </div>
        <div
          class="cell"
          :class="{ active: currentstate == '7' }"
          @click="tabSwitch('7')"
        >
          已完成
        </div>
        <div
          class="cell"
          :class="{ active: currentstate == '8' }"
          @click="tabSwitch('8')"
        >
          待结算
        </div>
        <div
          class="cell"
          :class="{ active: currentstate == '9' }"
          @click="tabSwitch('9')"
        >
          已作废
        </div>
      </div>
      <div class="cartbox">
        <div class="cartcon">
          <div class="flexbox searchbox">
            <div class="left">
              <el-form
                :inline="true"
                :model="formSearchA"
                class="demo-form-inline"
              >
                <el-form-item label="搜索关键词：">
                  <el-input v-model="formSearchA.keyword"></el-input>
                </el-form-item>
                <el-form-item label="下单时间：">
                  <div style="display: flex">
                    <el-date-picker
                      type="date"
                      placeholder="开始日期"
                      v-model="formSearchA.date1"
                      style="width: 100%"
                      @change="
                        dateLimit('start', formSearchA.date1, formSearchA.date2)
                      "
                    ></el-date-picker>

                    -

                    <el-date-picker
                      type="date"
                      placeholder="结束日期"
                      v-model="formSearchA.date2"
                      style="width: 100%"
                      @change="
                        dateLimit('end', formSearchA.date1, formSearchA.date2)
                      "
                    ></el-date-picker>
                  </div>
                </el-form-item>
                <el-form-item label="销售类别">
                  <el-select
                    filterable
                    v-model="formSearchA.sellType"
                    clearable
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in sellTypeList"
                      :key="item.SALE_NAME"
                      :label="item.SALE_NAME"
                      :value="item.SALE_NAME"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </div>
            <div class="flexbox right">
              <el-button type="primary" @click="conditionSearch" plain
                >搜索</el-button
              >
              <el-button @click="clearSearch">重置</el-button>
              <!-- <p>更多搜索条件</p> -->
            </div>
          </div>
          <div class="nodata" v-if="orderList.length == 0">
            <el-empty description="暂无订单"></el-empty>
          </div>
          <div class="flexbox overview" v-if="orderList.length != 0">
            <div class="left">
              <div class="ordernum">总单号：{{ zordermsg.totalOrderNo }}</div>
              <div class="ordermsg">
                <span>下单时间：{{ zordermsg.cttime }}</span>
                <span>拆单状态：{{ zordermsg.orderState }}</span>
                <span>{{count}}</span>
              </div>
            </div>
            <!-- <div class="flexbox right">
                            <p>注：</p>
                            <div class="tips">
                                <p>1. 您本次订单包含玛钢、沟槽、阀门等<span class="redw">三类产品25个单品</span>，请您开始<span class="redw">核对本单信息。</span></p>
                                <p>2. 本次订单已经按照库存及产品类型进行了分单操作。</p>
                                <p>3. 请您对每一笔订单的<span class="redw">到货时间、开票方、抬头进行确认。</span></p>
                                <p>4. 请您核对最终的<span class="redw">优惠、商业折扣内容。</span></p>
                            </div>
                        </div> -->
          </div>
          <div class="ordercon">
            <div class="item" v-for="item in orderList" :key="item.tohSeq">
              <h2 class="flexbox">
                <p>订单号：{{ item.tohSeq }}</p>
                <p>拆单时间：{{ item.splitTime }}</p>
              </h2>
              <div
                class="flexbox cell"
                v-for="it in item.proData"
                :key="it.todSeq"
              >
                <div class="flexbox left">
                  <div class="flexbox msg">
                    <div class="img">
                      <img
                        src="https://online.meide-casting.com/meide/la.img?fn"
                      />
                    </div>
                    <div class="name">
                      <p>{{ it.proName }}</p>
                      <p>{{ it.code }}</p>
                      <span>规格:</span>
                      <span class="redw" style="margin-right: 8px">{{
                        it.gg
                      }}</span>
                      <span>表面:</span>
                      <span class="redw" style="margin-right: 8px">{{
                        it.bm
                      }}</span>
                      <span>品种:</span>
                      <span class="redw">{{ it.pz }}</span>
                      <div>
                        <span v-if="it.jq">胶圈:</span>
                        <span
                          v-if="it.jq"
                          class="redw"
                          style="margin-right: 8px"
                          >{{ it.jq }}</span
                        >
                        <span v-if="it.lslm"> 螺栓螺母:</span>
                        <span
                          v-if="it.lslm"
                          class="redw"
                          style="margin-right: 8px"
                          >{{ it.lslm }}</span
                        >
                      </div>
                    </div>
                  </div>
                  <div class="price">
                    <p class="">¥{{ it.price }}</p>
                    <p>单价</p>
                  </div>
                  <div class="num">
                    <p class="">{{ it.num }}个</p>
                    <p>数量</p>
                  </div>
                  <div class="cases">
                    <p class="">{{ it.boxNum }}箱</p>
                    <p>箱数</p>
                  </div>
                  <div class="total">
                    <p class="redw">¥{{ it.subAmount }}</p>
                    <p>支付</p>
                  </div>
                </div>
                <div class="right">
                  <el-button type="primary">{{ it.stateStr }}</el-button>
                  <router-link
                    :to="{
                      name: 'Settlement',
                      params: { id: zordermsg.totalOrderNo },
                    }"
                    v-if="it.stateStr == '待结算'"
                    >前往结算</router-link
                  >
                  <router-link
                    :to="{
                      name: 'OrderDetail',
                      query: { ordercode: it.todSeq },
                    }"
                    target="_blank"
                    v-if="it.stateStr != '待结算'"
                    >查看详情</router-link
                  >
                  <router-link
                    :to="{ name: 'Logistics', query: { ordercode: it.todSeq } }"
                    target="_blank"
                    v-if="it.stateStr != '待结算'"
                    >查看物流</router-link
                  >
                </div>
              </div>
              <div class="flexbox note">
                <div class="flexbox notecon">
                  <span>订单备注：</span>
                  <el-input v-model="item.note" disabled></el-input>
                </div>
                <div class="flexbox total">
                  <p>
                    重量总计：<span class="">{{ item.totalWeight }}KG</span>
                  </p>
                  <p>
                    总箱数：<span class="">{{ item.totalBoxNum }}</span>
                  </p>

                  <p>
                    共<span class="">{{ item.proNum }}</span
                    >种商品
                  </p>
                  <p>
                    小计：<span class="largew redw">¥{{ item.amount }}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <el-pagination
            @current-change="handleCurrentChange"
            v-model:currentPage="currentPage"
            :page-size="1"
            :total="totalNum"
            layout="prev, pager, next, jumper"
            background
            v-if="orderList.length != 0"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive, toRefs, getCurrentInstance, onBeforeMount } from "vue";
import { useRouter } from "vue-router";
import { formatDate, formatHMS } from "@/util/util.js";
import { ElMessage } from "element-plus";

export default {
  
  name: "MyOrder",
  components: {},
  setup() {
    let { proxy } = getCurrentInstance();
    let router = useRouter();
    let pageData = reactive({
      zordermsg: "",
      orderList: [],
      currentstate: "1",
      dateState: [
        { name: "近三个月订单", val: "1" },
        { name: "近六个月订单", val: "2" },
        { name: "近一年订单", val: "3" },
        { name: "一年前订单", val: "4" },
      ],
      sellTypeList: [], //销售类别列表
      dateStateS: "1",
      // 订单筛选条件
      formSearchA: {
        keyword: "",
        date1: "",
        date2: "",
        sellType: "", //销售类别
        // cpdl: '',
        // ddlx: '',
        // xslb: '',
        // kclx: '',
        // pz: '',
        // gg: '',
        // bhxs: '',
        // cz: '',
        // bmcl: '',
        // xs: '',
        // zt: ''
      },
    });
    // 选择tab
    let tabSwitch = (val) => {
      pageData.currentstate = val;
      getOrder();
    };
    let stateChange = () => {
      pageData.currentstate = pageData.dateStateS;
      getOrder();
    };
    let focusstate = () => {
      pageData.dateStateS = "";
    };
    // 条件搜索
    let conditionSearch = () => {
      getOrder();
    };
    // 重置条件搜索
    let clearSearch = () => {
      pageData.formSearchA.keyword = "";
      pageData.formSearchA.date1 = "";
      pageData.formSearchA.date2 = "";
      getOrder();
    };
// 外面全局定义
let count=ref('') 
//  let a=  timestampToTime(1635564500000);
let	getYMDHMS= (timestamp)=> {
      let time = new Date(timestamp)
      let year = time.getFullYear()
      let month = time.getMonth() + 1
      let date = time.getDate()
      let hours = time.getHours()
      let minute = time.getMinutes()
      let second = time.getSeconds()

      if (month < 10) { month = '0' + month }
      if (date < 10) { date = '0' + date }
      if (hours < 10) { hours = '0' + hours }
      if (minute < 10) { minute = '0' + minute }
      if (second < 10) { second = '0' + second }
      return year + '-' + month + '-' + date + ' ' + hours + ':' + minute + ':' + second
    }
  
    let fangfa = (endDate) => {
      var date = new Date();
      var now = date.getTime();
      //var endDate = new Date("2019/7/22 00:00:00");
      var end = endDate.getTime();
      //时间差
      var differTime = end - now;
      //定义变量,h,m,s保存倒计时的时间
      var h, m, s;
      if (differTime >= 0) {
        h = Math.floor(differTime / 1000 / 60 / 60);
        m = Math.floor((differTime / 1000 / 60) % 60);
        s = Math.floor((differTime / 1000) % 60);
        h = h < 10 ? "0" + h : h;
        m = m < 10 ? "0" + m : m;
        s = s < 10 ? "0" + s : s;
        let timeDom = "剩余支付时间：" + h + "小时" + m + "分" + s + "秒";
         // *******  这是个很重要的赋值
        count.value=timeDom

        // $("#active_time").text(timeDom);
       // console.log(timeDom,'333333333333');

        //递归调用函数所以是延时器不是定时器
        setTimeout(function () {
          fangfa(endDate);
        }, 1000);
      } else {
        // todo 如果超时了，怎么处理
        // var timeDom = "00小时 00分 00秒";
        // $("#active_time").text(timeDom);
      }
    };

    // 查询订单
    let getOrder = () => {
      let startTime =
        pageData.formSearchA.date1 == null ? "" : pageData.formSearchA.date1;
      let endTime =
        pageData.formSearchA.date2 == null ? "" : pageData.formSearchA.date2;
      let data = {
        postType: "queryOrderList",
        start: currentPage.value, // 起始页
        limit: "", // 每页多少条
        param: pageData.formSearchA.keyword, // 搜索框内容，支持订单号、产品名称模糊查询
        sellType: pageData.formSearchA.sellType, //销售类别
        startTime: startTime == "" ? "" : formatDate(startTime), // 开始时间
        endTime: endTime == "" ? "" : formatDate(endTime), // 结束时间
        tab: pageData.currentstate, // 数值传1~7：1.近三个月订单 2.近6个月订单 3.一年内订单 4.一年前订单 5.待发货 6.待收货 7.已完成
      };
      proxy.$axios
        .postReq("/meide/REST/ajaxOrderList", data)
        .then((res) => {
          if (res.success == "true") {
            pageData.zordermsg = res;

            let a = Number(new Date(res.cttime).getTime()) + Number(60 * 60 * 1000)
            // console.log(new Date(res.cttime).getTime() + '::::666666666666666')
       
        let b=new Date(getYMDHMS(a))
        // console.log(b,'倒计时时间8888888888')

            // let b = new Date().getTime();
            // let chayi = a - b;
            // console.log(chayi + 'ssss');
            // // console.log(formatDate(chayi) + '666');
            // let yyyy = jutils.formatDate(new Date(chayi),"YYYY-MM-DD HH:ii:ss");
            // console.log(yyyy + 'ssss')
            // let ff = toHHmmss(chayi).substring(0, toHHmmss(chayi).length - 4);
            fangfa(b);  
            // console.log(b,'78787878887878')
            let shij = fangfa(b)
            res.data.map((item) => {
              item.totalWeight = item.totalWeight.toFixed(2);
            });
            pageData.orderList = res.data;
            totalNum.value = parseFloat(res.rowcount);
            // pageData.conditionList = res.items
          } else {
            proxy.$alert(res.ErrorText, "提示", {
              confirmButtonText: "确定",
              callback: (action) => {},
            });
          }
        })
        .catch((error) => {
          // proxy.$alert(error, '提示', {
          //     confirmButtonText: '确定',
          //     callback: action => {}
          // });
        });
    };
    // 查询筛选条件-下拉
    let getstockTypeList = (bhxs) => {
      let data = {
        postType: "getStockType",
        bhxs: bhxs, // 包含形式（筛选条件）
      };
      proxy.$axios
        .postReq("/meide/REST/ajaxSelectProduct", data)
        .then((res) => {
          if (res.success == "true") {
            pageData.stockTypeList = res.data;
            pageData.stockType = "";
          } else {
            proxy.$alert(res.ErrorText, "提示", {
              confirmButtonText: "确定",
              callback: (action) => {},
            });
          }
        })
        .catch((error) => {
          // proxy.$alert(error, '提示', {
          //     confirmButtonText: '确定',
          //     callback: action => {}
          // });
        });
    };
    // 分页
    let currentPage = ref(1);
    let totalNum = ref(0);
    let handleCurrentChange = (val) => {
      currentPage.value = val;
      getOrder();
    };
    // 日期选择限制
    let dateLimit = (Timetype, startTime, endTime) => {
      // datePickerLimit(Timetype, startTime, dateb)
      if (Timetype == "start") {
        if (
          endTime != "" &&
          startTime != null &&
          startTime.getTime() > endTime.getTime()
        ) {
          ElMessage.error("开始日期不能晚于结束日期");
          pageData.formSearchA.date1 = "";
        } else {
        }
      }
      if (Timetype == "end") {
        if (
          startTime != "" &&
          endTime != null &&
          endTime.getTime() < startTime.getTime()
        ) {
          ElMessage.error("结束日期不能早于开始日期");
          pageData.formSearchA.date2 = "";
        } else {
        }
      }
      // pageData.formProblem.date1 = ''
    };
    //获取销售类别列表的接口
    let getSellTypeList = () => {
      proxy.$axios
        .postReq("/meide/REST/ajaxSalesTargetsDropDown", {
          postType: "salesType",
        })
        .then((res) => {
          pageData.sellTypeList = res.items;
        });
    };
    onBeforeMount(() => {
      if (router.currentRoute.value.params.tab) {
        pageData.currentstate = router.currentRoute.value.params.tab;
      } else {
        pageData.currentstate = "1";
      }
      getSellTypeList();
      getOrder();
    });
    return {
      ...toRefs(pageData),
      tabSwitch,
      stateChange,
      focusstate,
      getOrder,
      getstockTypeList,
      conditionSearch,
      currentPage,
      totalNum,
      handleCurrentChange,
      clearSearch,
      dateLimit,
      count
    };
  },
};
</script>

<style scoped lang="scss">
.main {
  padding-bottom: 50px;
  h1 {
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 15px;
  }
}
.maincon {
  width: 1200px;
  margin: auto;
  padding-top: 10px;
}
.bread {
  font-size: 12px;
  margin-bottom: 10px;
}
.tabs {
  background: #fafafa;
  border: 1px solid #d7d7d7;
  margin-bottom: 10px;
  .cell {
    padding: 10px 30px;
    text-align: center;
    border-right: 1px solid #d7d7d7;
    border-top: 3px solid #fafafa;
    cursor: pointer;
    &:hover {
      color: rgb(244, 36, 52);
    }
  }
  .cell.active {
    border-top: 3px solid rgb(244, 36, 52);
    background: #fff;
    color: rgb(244, 36, 52);
    padding: 10px 40px;
  }
  ::v-deep(.el-input__inner) {
    width: 150px;
    background: none;
    border: none;
    border-right: 1px solid #d7d7d7;
  }
  .selcell.active {
    border-top: 3px solid rgb(244, 36, 52);
    background: #fff;
    ::v-deep(.el-input__inner) {
      color: rgb(244, 36, 52);
    }
  }
}
.cartbox {
  padding-bottom: 200px;
  .cartcon {
    .searchbox {
      padding: 10px 0;
      align-items: flex-start;
      justify-conten: space-between;
      .left {
        width: 1000px;
        ::v-deep(.el-input__inner) {
          height: 40px;
          width: 180px;
        }
        ::v-deep(.el-col-8 .el-input__inner) {
          width: 100%;
        }
      }
      .right {
        .el-button {
          height: 34px;
          margin-right: 20px;
        }
      }
    }
    .overview {
      background: #fafafa;
      padding: 20px 30px;
      border-top: 2px solid rgba(244, 36, 52, 1);
      justify-content: space-between;
      .left {
        .ordernum {
          padding: 5px 20px;
          color: #fff;
          background: rgba(244, 36, 52, 1);
          border-radius: 200px;
          display: inline-block;
        }
        .ordermsg {
          margin-top: 20px;
          span {
            font-size: 12px;
            color: #666;
            margin-right: 15px;
          }
        }
      }
      .right {
        align-items: flex-start;
        p {
          font-size: 12px;
          color: #666;
        }
        .redw {
          font-size: 12px;
        }
      }
    }
    .ordercon {
      border: 1px solid rgba(215, 215, 215, 1);
      background: #fff;
      .item {
        h2 {
          padding: 15px 30px;
          background: #fafafa;
          border-top: 1px solid rgba(215, 215, 215, 1);
          p {
            font-size: 12px;
            color: #666;
            margin-right: 25px;
          }
        }
        .cell {
          padding: 0 15px;
          border: 1px solid rgb(235, 235, 235);
          justify-content: space-between;
          & > div > p {
            color: #666;
            font-size: 12px;
          }
          & > div > p.redw {
            color: rgb(244, 36, 52);
            font-size: 14px;
          }
          div {
            margin: 0 2px;
          }
          .msg {
            width: 450px;
            padding: 20px 0;
            .img {
              border: 1px solid rgb(235, 235, 235);
              margin-right: 10px;
              img {
                width: 102px;
                height: 102px;
              }
            }
            .name {
              p {
                margin-bottom: 5px;
              }
              span {
                font-size: 12px;
              }
            }
          }
          .stock {
            width: 80px;
            text-align: center;
          }
          .deliver {
            width: 100px;
            text-align: center;
          }
          .price {
            width: 120px;
            text-align: center;
          }
          .num {
            width: 120px;
            text-align: center;
          }
          .cases {
            width: 120px;
            text-align: center;
          }
          .weight {
            width: 100px;
            text-align: center;
          }
          .total {
            width: 150px;
            text-align: center;
          }
        }
        .right {
          text-align: center;
          padding: 20px 25px;
          border-left: 1px solid #ebebeb;
          a {
            display: block;
            color: #333;
            font-size: 13px;
            margin-top: 10px;
          }
          a:hover {
            color: rgba(244, 36, 52, 1);
          }
        }
        .note {
          padding: 20px 15px;
          justify-content: space-between;
          .notecon {
            span {
              font-size: 12px;
              width: 70px;
            }
            ::v-deep(.el-input__inner) {
              height: 30px;
              width: 400px;
            }
          }
          .total {
            p {
              font-size: 12px;
              margin-left: 20px;
            }
            .redw {
            }
            .largew {
              font-size: 20px;
              font-weight: bold;
            }
          }
        }
      }
    }
  }
}
::v-deep(.el-pagination) {
  margin-top: 50px;
  text-align: right;
}
::v-deep(.el-pagination.is-background .el-pager li:hover) {
  background: rgba(255, 0, 0, 1);
  color: #fff;
}
</style>